<template>
  <div class="edit">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item href="/user/userTrackList">学员跟踪记录</Breadcrumb-item>
        <Breadcrumb-item>添加跟踪记录</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <Form ref="form" :model="formValidate" :rules="ruleValidate" :label-width="90" class="form">
      <Row>
        <Col :sm="11" :md="5">
          <Form-item label="学生ID" prop="uid">
            <Input :readonly="uidReadonly" v-model.number="formValidate.uid" :maxlength="10" :disabled="disable"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="5">
          <Form-item label="学生姓名" prop="nickname">
            <Input readonly placeholder="只读"
              v-model="formValidate.nickname" :disabled="disable"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="5">
          <Form-item label="课程顾问" prop="adviserName">
            <Input readonly placeholder="只读"
              v-model="formValidate.adviserName" :disabled="disable"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="5">
          <Form-item label="学导" prop="studyAdviserName">
            <Input readonly placeholder="只读"
              v-model="formValidate.studyAdviserName" :disabled="disable"></Input>
          </Form-item>
        </Col>
      </Row>
      <Row v-if="$route.query.id">
        <Col :sm="22" :md="18">
          <Form-item label="历史跟踪记录">
            <Table size="small" :columns="userTrackRecordColumns" :data="userTrackRecordList"></Table>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="22" :md="18">
          <Form-item label="内容" prop="content">
            <Input v-model="formValidate.content" type="textarea" :autosize="{minRows: 3, maxRows: 10}"></Input>
            <div style="margin-top: 8px">
              <Button type="primary" ghost size="small" :loading="aiLoading" :disabled="aiLoading" @click="handleAiMarkdown">AI 处理</Button>
              <span style="margin-left: 8px; color: #999; font-size: 12px">将通话/听记原文清洗为结构化 Markdown</span>
            </div>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="11" :md="5">
          <Form-item label="下次联系日期">
            <Date-picker type="date" :clearable="false" @on-change="nextTimeDateChange"
              v-model="formValidate.nextTimeDate"></Date-picker>
          </Form-item>
        </Col>
        <Col :sm="11" :md="5">
          <Form-item label="下次联系人">
            <Select v-model.number="formValidate.nextHandlerId" filterable>
              <Option v-for="item in nextHandler"
                :value="item.id" :key="item.id">{{ item.nickname }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :sm="11" :md="5">
          <Form-item label="记录属性" prop="traceType" v-if="trackType =='' || trackType ==null">
            <Select v-model="formValidate.traceType" transfer>
              <Option value="1">新注册学生</Option>
              <Option value="11">分配记录</Option>
              <Option value="21">试听课记录</Option>
              <Option value="31">成交记录</Option>
              <Option value="41">交接记录</Option>
              <Option value="51">绑定记录</Option>
              <Option value="61">上课跟进记录</Option>
              <Option value="71">转介绍跟进记录</Option>
              <Option value="99">其他</Option>
              <Option value="100">注册备注</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
      <Form-item>
        <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
      </Form-item>
    </Form>
    <Modal v-model="contentVisible" title="跟踪记录内容" width="720" :mask-closable="false">
      <div style="margin-bottom: 12px;">
        <Radio-group v-model="contentViewMode" type="button" size="small" @on-change="switchContentView">
          <Radio label="markdown">Markdown</Radio>
          <Radio label="raw" :disabled="!contentRawText">原文</Radio>
        </Radio-group>
        <span v-if="!contentRawText" style="margin-left:8px;color:#999;font-size:12px;">无原始内容</span>
      </div>
      <div v-if="contentViewMode === 'markdown'" ref="contentExportArea" class="track-md track-md-dialog" v-html="contentHtml"></div>
      <pre v-else ref="contentExportArea" class="track-raw-dialog">{{ contentRawText }}</pre>
      <div slot="footer">
        <Button :loading="exportImageLoading" :disabled="exportImageLoading || (contentViewMode==='markdown' ? !contentHtml : !contentRawText)" @click="exportContentPng">导出 PNG</Button>
        <Button type="primary" @click="contentVisible = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import { renderSimpleMarkdown } from '@/utils/simpleMarkdown'
  import TrackContentPreview from './TrackContentPreview.vue'
  import html2canvas from 'html2canvas'
  export default {
    components: { TrackContentPreview },
    data () {
      // let $moment = this.$moment
      return {
        nextHandler: [],
        uidReadonly: false,
        trackType: '',
        nextTimeDate: '',
        disable: false,
        aiLoading: false,
        contentVisible: false,
        contentHtml: '',
        contentRawText: '',
        contentViewMode: 'markdown',
        contentMeta: {},
        exportImageLoading: false,
        formValidate: {
          id: '',
          uid: null,
          nickname: '',
          adviserName: '',
          studyAdviserName: '',
          content: '',
          nextHandlerId: null,
          status: '0',
          traceType: '',
          nextHandlerTime: '',
        },
        ruleValidate: {
          uid: [
            { validator: this.validateUid, trigger: 'blur' },
            { type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' },
            { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' }
          ],
          content: [
            { required: true, message: '内容不能为空', trigger: 'blur' },
            { type: 'string', max: 10000, message: '内容不能超过10000个字', trigger: 'blur' }
          ],
          traceType: [
            { required: true, message: '属性不能为空', trigger: 'blur' },
          ],
          nextHandlerId: [
            { type: 'number', required: true, message: '请选择下次联系人', trigger: 'blur' },
          ]
        },
        userTrackRecordList: [],
        userTrackRecordColumns: [
          {
            title: '内容',
            minWidth: 220,
            key: 'content',
            render: (h, params) => {
              let row = params.row
              return h('TrackContentPreview', {
                props: { content: row.content },
                on: { view: () => this.openContentView(row) }
              })
            }
          },
          {
            title: '处理人',
            width: 100,
            key: 'nextHandlerName',
          },
          {
            title: '处理时间',
            width: 100,
            key: 'createTime',
          }
        ]
      }
    },
    created () {
      this.disable = false
      let uid = this.$route.query.uid
      if (uid) {
        this.disable = true
        this.formValidate.uid = parseInt(uid)
        let self = this
        self.$http.get('/user/queryById?uid=' + uid).then(function (res) {
          if (res.data) {
            self.formValidate.nickname = res.data.nickname
            self.formValidate.adviserName = res.data.adviserName
            self.formValidate.studyAdviserName = res.data.studyAdviserName
          }
        })
      }
    },
    mounted () {
      let self = this
      let formValidate = this.formValidate
      formValidate.id = this.$route.query.id
      formValidate.traceType = this.$route.query.traceType
      this.trackType = formValidate.traceType
      this.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
        self.nextHandler = res.data
      })

      // 有id 表示为编辑
      if (!this.formValidate.id || this.formValidate.id === '') {
        return
      }
      self.uidReadonly = true
      this.$http.get('/userTrack/queryById?id=' + this.formValidate.id).then(function (res) {
        if (!res || !res.data) {
          return
        }
        let userTrack = res.data
        formValidate.uid = userTrack.uid
        formValidate.nickname = userTrack.nickname
        formValidate.adviserName = userTrack.adviserName
        formValidate.studyAdviserName = userTrack.studyAdviserName
        if (!formValidate.traceType) {
          formValidate.traceType = userTrack.traceType
        }
        self.listOldTrace(userTrack)
      })
    },
    methods: {
      openContentView (row) {
        if (!row || !row.content) {
          this.$Message.warning('暂无内容')
          return
        }
        this.contentMeta = {
          uid: row.uid || this.formValidate.uid || '',
          id: row.id || '',
          createTime: row.createTime || ''
        }
        this.contentHtml = renderSimpleMarkdown(row.content)
        this.contentRawText = row.contentRaw || ''
        this.contentViewMode = 'markdown'
        this.contentVisible = true
      },
      switchContentView () {
      },
      exportContentPng () {
        let el = this.$refs.contentExportArea
        if (!el || (this.contentViewMode === 'markdown' ? !this.contentHtml : !this.contentRawText)) {
          this.$Message.warning('暂无内容可导出')
          return
        }
        this.exportImageLoading = true
        let self = this
        // Modal body / .track-md-dialog 有 max-height+overflow，html2canvas 只会截可见区。
        // 离屏克隆整页高度再截（参考 LevelRecordList 的 scrollWidth/Height），弹窗内仍可滚动查看。
        let width = Math.max(el.clientWidth || 0, 680)
        let holder = document.createElement('div')
        holder.setAttribute('data-track-png-export', '1')
        holder.style.cssText = 'position:absolute;left:-10000px;top:0;width:' + width + 'px;background:#fff;'
        let clone = el.cloneNode(true)
        clone.className = (el.className || '').replace(/\btrack-md-dialog\b/g, ' ').replace(/\s+/g, ' ').trim()
        if ((' ' + clone.className + ' ').indexOf(' track-md ') < 0) {
          clone.className = (clone.className + ' track-md').trim()
        }
        clone.style.cssText = 'max-height:none!important;overflow:visible!important;height:auto!important;width:' + width + 'px;background:#fff;padding:8px;box-sizing:border-box;'
        holder.appendChild(clone)
        document.body.appendChild(holder)
        let cleanup = function () {
          if (holder && holder.parentNode) {
            holder.parentNode.removeChild(holder)
          }
        }
        void clone.offsetHeight
        let w = Math.max(clone.scrollWidth, width)
        let h = Math.max(clone.scrollHeight, clone.offsetHeight, 1)
        html2canvas(clone, {
          scale: 2,
          backgroundColor: '#ffffff',
          useCORS: true,
          logging: false,
          width: w,
          height: h,
          windowWidth: w,
          windowHeight: h
        }).then(canvas => {
          cleanup()
          let meta = self.contentMeta || {}
          let stamp = String(meta.createTime || '').replace(/[^\d]/g, '')
          let link = document.createElement('a')
          link.download = '跟踪记录_' + (meta.uid || '') + (meta.id ? '_' + meta.id : '') + (stamp ? '_' + stamp : '') + '.png'
          link.href = canvas.toDataURL('image/png')
          link.click()
          self.exportImageLoading = false
          self.$Message.success('导出成功')
        }).catch(() => {
          cleanup()
          self.exportImageLoading = false
          self.$Message.error('导出失败')
        })
      },

      listOldTrace (val) {
        let self = this
        if (val) {
          self.userTrackRecordList.push(val)
          if (val.traceNode) {
            self.listOldTrace(val.traceNode)
          }
        }
      },
      nextTimeDateChange (value) {
        this.formValidate.nextHandlerTime = value
      },
      validateUid (rule, value, callback) {
        let self = this
        let formValidate = self.formValidate
        console.log(formValidate.uid)
        if (!value) {
          return callback()
        }
        self.$http.post('/user/queryById', {'uid': value}).then(function (res) {
          let user = res.data
          if (!user) {
            formValidate.nickname = ''
            formValidate.adviserName = ''
            formValidate.nextHandlerId = ''
            formValidate.studyAdviserName = ''
            return callback(new Error('学生ID不存在'))
          }
          formValidate.nickname = user.nickname || ''
          formValidate.adviserName = user.adviserName || ''
          formValidate.studyAdviserName = user.studyAdviserName || ''
          return callback()
        })
      },
      handleAiMarkdown () {
        let self = this
        let content = (self.formValidate.content || '').trim()
        if (!content) {
          self.$Message.warning('请先填写内容')
          return
        }
        self.aiLoading = true
        self.$http.post('/userTrack/aiMarkdown', {content: content}).then(function (res) {
          self.aiLoading = false
          if (!res || res.status !== 'ok' || !res.data || !res.data.markdown) {
            return
          }
          let markdown = res.data.markdown
          self.$Modal.confirm({
            title: '确认覆盖',
            content: '将用 AI 结果覆盖当前内容，是否继续？',
            onOk: function () {
              // 首次 AI 覆盖前保留原文，避免清洗后丢失
              if (!(self.formValidate.contentRaw || '').trim()) {
                self.formValidate.contentRaw = content
              }
              self.formValidate.content = markdown
              self.$Message.success('已用 AI 结果更新内容')
            }
          })
        }).catch(function () {
          self.aiLoading = false
        })
      },
      handleSubmit (name) {
        let self = this
        this.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            return
          }
          if (self.formValidate.nextHandlerTime || self.formValidate.nextHandlerId) {
            if (!self.formValidate.nextHandlerTime || !self.formValidate.nextHandlerId) {
              self.$Message.warning('请填写下次联系人和下次联系日期!')
              return
            }
          }
          let path = '/userTrack/update'
          if (!this.formValidate.id || this.formValidate.id === '') {
            path = '/userTrack/insert'
          }
          self.$http.post(path, self.formValidate).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!')
              localStorage.setItem('userTraceUid', self.formValidate.uid)
              self.$router.push('/user/personUserTrackList')
            }
          })
        })
      }
    },
    watch: {
    }
  }
</script>

<style scoped>
.track-md { text-align: left; line-height: 1.5; font-size: 14px; }
.track-raw-dialog {
  max-height: 60vh;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  padding: 8px;
  background: #fafafa;
  border: 1px solid #eee;
  font-size: 13px;
  line-height: 1.6;
}
.track-md-dialog {
  max-height: 60vh;
  overflow: auto;
  background: #fff;
  padding: 8px 4px;
}
.track-md /deep/ .md-table { border-collapse: collapse; width: 100%; margin: 4px 0; }
.track-md /deep/ .md-table th, .track-md /deep/ .md-table td { border: 1px solid #e8e8e8; padding: 2px 6px; }
.track-md /deep/ h2, .track-md /deep/ h3, .track-md /deep/ h4 { margin: 6px 0 4px; font-size: 14px; }
.track-md /deep/ ul, .track-md /deep/ ol { padding-left: 18px; margin: 4px 0; }
.track-md /deep/ blockquote { margin: 4px 0; padding-left: 8px; border-left: 3px solid #ddd; color: #666; }
.track-md /deep/ p { margin: 2px 0; }
</style>



// WEBPACK FOOTER //
// UserTrackEdit.vue?fe9e52c6